export var containerStyle = `text-center 
    border border-dark border-4 rounded-0
    p-1
    mx-1 my-4 
    shadow bg-white`;
export var containerStyleGraphic = `text-center 
    text-white
    border border-black border-4 rounded-0
    p-5 
    mx-1 my-4 
    shadow bg-black`;
